
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/[slug]/shop",
      function () {
        return require("private-next-pages/brands/[slug]/shop/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/[slug]/shop"])
      });
    }
  